"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEventSelector = void 0;
const toSignatureHash_js_1 = require("./toSignatureHash.js");
exports.toEventSelector = toSignatureHash_js_1.toSignatureHash;
//# sourceMappingURL=toEventSelector.js.map